import { getOverviewCategories } from './getOverviewCategories';

export const categoryService = {
  getOverviewCategories,
};
